module.exports = __webpack_public_path__ + "static/media/icon-clipboard-list.3bdd792c.svg";